<ng-container *ngIf="isLoaded()">
  <!-- Formularios en tarea o en modal sin wrapper -->
  <ng-container *ngIf="(task || windowHash); else templateWrapper">
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </ng-container>
  <!-- <ng-template #templateBase>
    <ng-container *ngIf="windowHash; else templateWrapper">
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
    </ng-container>
  </ng-template> -->
  <ng-template #templateWrapper>
    <div class="wrapper wrapper-content BASEFORMINMODAL" *ngIf="!windowHash">
      <!--div class="row m-t-sm">
        <div class="col-12 p-0">
          <input type="text" class="p-inputtext" placeholder="{{ 'General.filterPlaceholder' | translate }}"
            name="filterText" id="filterTextInput" [(ngModel)]="filterText" (ngModelChange)="updateFilter()"
            autocomplete="off" />
        </div>
    </div-->
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
      <div class="row">
        <div class="col-12">
          <!-- <p-tree [value]="groupedInfo" class="col-6"></p-tree> -->
          <p-treeTable [value]="groupedInfo" class="col-12" [loading]="loading" (onNodeExpand)="onNodeExpand($event)">
            <ng-template pTemplate="emptymessage">
              <tr>
                <td> {{ 'General.noData' | translate }} </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 50%;"></th>
                <th style="width: 10%;">{{'ControlPanel.organizationalunits.unitAsRecruiting'|translate}}</th>
                <th style="width: 10%;">{{'ControlPanel.organizationalunits.entity'|translate}}</th>
                <th style="width: 10%;">{{'ControlPanel.organizationalunits.unitId'|translate}}</th>
                <th style="width: 10%;">{{'ControlPanel.organizationalunits.cif'|translate}}</th>
                <th class="action-column-4buttons"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
              <tr [ttRow]="rowNode">
                <td>
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <i *ngIf="!rowData.root" class="far fa-file px-1 fa-1-5x" aria-hidden="true"></i>
                  <i *ngIf="rowData.root" class="far fa-folder px-1 fa-1-5x" aria-hidden="true"></i>
                  [{{rowData.unitId}}] {{rowData.name}}
                </td>
                <td>
                  <i *ngIf="rowData.unitAsRecruiting" class="fas fa-check px-1 fa-1-5x" aria-hidden="true"></i>
                </td>
                <td>
                  <i *ngIf="rowData.entity" class="fas fa-check px-1 fa-1-5x" aria-hidden="true"></i>
                </td>
                <td>{{rowData.identifier}}</td>
                <td>{{rowData.cif}}</td>
                <!-- columna de botones-->
                <td class="action-column-4buttons">
                  <div class="btn-group">
                    <button class="btn btn-outline-secondary btn-sm t-action-button" tabindex="-1"
                      title="{{ 'General.view' | translate}}" type="button" (click)="show(rowData)">
                      <i class="fas fa-eye" aria-hidden="true"></i>
                    </button>
                    <button class="btn  btn-primary btn-sm t-action-button" type="button"
                      title="{{ 'General.edit' | translate}}">
                      <i class="fas fa-pencil-alt" aria-hidden="true" (click)="edit(rowData)"></i>
                    </button>
                    <button class="btn btn-outline-secondary btn-sm t-action-button" tabindex="-1"
                      title="{{ 'General.delete' | translate}}" type="button" (click)="deleteOrg(rowData)">
                      <i class="fas fa-times" aria-hidden="true"></i>
                    </button>
                    <pmenu-actions [dto]="rowData" [lazy]="true" [dtoType]="'ORGANIZATIONALUNIT'"
                      (reload)="this.onActionExecute()">
                    </pmenu-actions>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-treeTable>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #formTemplate>
    <!-- COMENTARIO DE RECHAZO PARA FORMULARIOS QUE GESTIONAN DOCUMENTOS -->
    <div #rejectionPanelContainer></div>
    <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig"></formPlyca>
  </ng-template>
</ng-container>